import React from 'react';
import { FieldArray } from 'redux-form';

import SalesTypeItemVariantsContainer from './SalesTypeItemVariantsContainer';

class SalesTypeItemVariantsList extends React.Component {
  render() {
    const { fields, index } = this.props;
    const defaultValue = { price: undefined, sku: undefined };
    const dataProps = {
      salesType: fields.get(index),
    };
    return (
      <div>
        <div className={`row form-group`}>
          <div className="form-group col-sm-12">
            <span className={`pull-left`}>
              <strong>{fields.get(index).name}</strong>
            </span>
          </div>
          <FieldArray
            name="item_variants"
            component={SalesTypeItemVariantsContainer}
            defaultValue={defaultValue}
            placeholder="price"
            props={dataProps}
          />
        </div>
      </div>
    );
  }
}

export default SalesTypeItemVariantsList;
